import React from 'react'
export default ({ fontFamily, colors, email }) => {
    return <tr>
    <td valign="top" style={{ fontSize: 0 }}>
        <p
            style={{
                fontSize: 11,
                fontFamily,
                margin: 0,
                lineHeight: "120%",
                display: "block"
            }}
        >
            <a
                href={`mailto:${email}`}
                style={{
                    textDecoration: "none",
                    color: colors.signal,
                }}
            >{email}</a>
        </p>
    </td>
</tr>
}
